/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor, dlsDarkColor} from '../theme/theme';
import {useThemeMode} from '../theme/useThemeContext';

/**
 * Defines the Design Language System (DLS) current theme resize grabber
 * pull tab icon, rendered as the drag handle for the current theme
 * ResizeGrabber.
 *
 * ```typescript
 *
 *  import {ResizeGrabberPullTabIcon} from '@ion/dls/src/icons/ResizeGrabberPullTabIcon';
 *
 *  <ResizeGrabberPullTabIcon />
 *
 * ```
 */
export const ResizeGrabberPullTabIcon = () => {
  const {isDark}  = useThemeMode();
  const arrowFill = dlsDarkColor(isDark, 'grey1', '#333333');
  return (
    <svg width='78' height='32' viewBox='0 0 78 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_19155_23366)'>
        <path d='M4 16C4 11.5817 7.58172 8 12 8H66C70.4183 8 74 11.5817 74 16V32H4V16Z'
          fill={dlsColor('white')}
          fillOpacity='0.7'
          shapeRendering='crispEdges' />
        <path d='M44 18L39 13L34 18L44 18Z' fill={arrowFill} />
        <path d='M34 22L39 27L44 22H34Z' fill={arrowFill} />
      </g>
      <defs>
        <filter id='filter0_d_19155_23366' x='0' y='0' width='78' height='32'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha' />
          <feOffset dy='-4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_19155_23366' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_19155_23366' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default ResizeGrabberPullTabIcon;
